import { Component, Vue, Watch } from 'vue-property-decorator';

import template from './forgot-password.vue';
import apiService from '@/services/api.service';

@Component({
  mixins: [template],
})
export default class ForgotPassword extends Vue {
  title: string = this.$package.title;
  userEmail: string = '';
  emailError: string = '';
  showSentMessage: boolean = false;

  @Watch('userEmail')
  updatePasswordError() {
    if ((this.emailError === 'invalid_syntax' && /.+@.+\.[a-zA-Z]+/.test(this.userEmail)) || (this.emailError === 'no_input' && this.userEmail.length)) {
      this.emailError = '';
    }
  }

  created() {
    document.addEventListener('keypress', this.onEnterPress);
  }

  beforeDestroy() {
    document.removeEventListener('keypress', this.onEnterPress);
  }

  onEnterPress(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.code === 'Enter' || event.charCode === 13) {
      this.sendForm();
    }
  }

  resetForm() {
    this.$router.push({ path: '/login' });
    this.userEmail = '';
  }

  async sendForm() {
    if (this.userEmail.length === 0) {
      this.emailError = 'no_input';
    } else if (!/.+@.+\.[a-zA-Z]+/.test(this.userEmail)) {
      this.emailError = 'invalid_syntax';
    } else {
      try {
        const result = await apiService.forgotPassword({ email: this.userEmail });
        if (result) {
          this.showSentMessage = true;
        }
      } catch (e) { }
    }
  }
}